import { RestaurantSearchItemResponse } from "./restaurant-search-item-response";

export class RestaurantSearchResponse {
    pageNumber: number;
    pageSize: number;
    pageTotal: number;
    totalItems: number;
    results: RestaurantSearchItemResponse[];
}